import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home';
import { BrowserRouter ,Routes,Route} from 'react-router-dom';
import Navbar from './Components/Navbar';
import Courses from './Pages/Courses';
import Classes from './Pages/Classes';
import Connect from './Pages/Connect';
import Portfolio from './Pages/Portfolio';
import { AuthContextProvider } from './Context/AuthContext';
import Login from './Pages/Login';
import { UserContextProvider } from './Context/UserContext';
import Manage from './Pages/Manage';
import GladiatorClass from './Pages/GladiatorClass';
import Chat from './Pages/Chat';
function App() {
  return (
    <UserContextProvider>
      <AuthContextProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/courses" element={<Courses/>}/>
            <Route path="/courses/:id" element={<Classes/>}/>
            <Route path="/connect" element={<Connect/>}/>
            <Route path="/chat" element={<Chat/>}/>
            <Route path="/manage" element={<Manage/>}/>
            <Route path="/glad_class" element={<GladiatorClass/>}/>
            <Route path="/portfolio/:id" element={<Portfolio/>}/>
          </Routes>
        </BrowserRouter>
      </AuthContextProvider>
    </UserContextProvider>
  );
}

export default App;
